import { createFileRoute } from '@tanstack/react-router'

import { FlowOfFundsPage } from '@/modules/insights/pages'

export const Route = createFileRoute(
  '/_authenticated/projects/$slug/insights/flow-of-funds',
)({
  component: FlowOfFundsPage,
})
